import { Injectable } from '@angular/core';
import { Router, Route, UrlSegment, UrlTree } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { ToastrService } from 'ngx-toastr';
import { SessionSecurityService } from '@shared/services';
import { MemberSearchService } from './member-search.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuardService {
    userInfo: any;
    allowAccess = false;
    fullPath: string;
    constructor(
        public router: Router,
        private toastr: ToastrService,
        private authService: MsalService,
        private memberSearchService: MemberSearchService,
        private sessionSecurity: SessionSecurityService) {
    }

    checkTokenExpiration(userInfo): boolean {
        if (!userInfo || typeof userInfo !== 'object') {
            return false;
        }
        const roles: any = userInfo.roles;
        if (!roles) {
            return false;
        }
        const hasRole = (r: string) => Array.isArray(roles) ? roles.includes(r) : roles.indexOf(r) > -1;
        if (hasRole('PortalAdmin') || hasRole('ChiefProfessionalOfficers') ||
            hasRole('CEODelegate') || hasRole('ChiefVolunteerOfficer') ||
            hasRole('RegionalServiceDirectors') || hasRole('AccountApprover') ||
            hasRole('NationalStaff') || hasRole('ApplicationOwner') ||
            hasRole('MilitaryApprovingOfficial') || hasRole('BGCAAlliance')) {
            this.allowAccess = true;
            return true;
        }
        this.toastr.info('You are not allowed to view this page', 'UnAuthorized Access');
        this.allowAccess = false;
        return false;
    }

    canMatch(route: Route, segments: UrlSegment[]): Observable<boolean | UrlTree> {
        this.fullPath = segments.reduce((path, currentSegment) => {
            return `${path}/${currentSegment.path}`;
        }, '');

        // Read UserId from sessionStorage first, fall back to localStorage
        const userId = this.sessionSecurity.getObject<string>('UserId')
            || this.sessionSecurity.getObjectLocalStorage<string>('UserId');

        // If userId not available yet, allow the route — MsalGuard handles auth
        if (!userId) {
            return of(true);
        }

        return this.memberSearchService.getMyInfo(userId).pipe(
            map(me => {
                this.userInfo = me;
                return this.userInfo ? this.checkTokenExpiration(this.userInfo) : true;
            }),
            catchError(() => of(true))
        );
    }
}
